import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteSatellite = (satelliteId: number) => {
  return axios.delete(`/api/satellites/${satelliteId}`);
};

type UseDeleteSatelliteOptions = {
  config?: MutationConfig<typeof deleteSatellite>;
};

export const useDeleteSatellite = ({ config }: UseDeleteSatelliteOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousSatellites) {
        queryClient.setQueryData(['satellites'], context.previousSatellites);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['satellites']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: deleteSatellite,
  });
};
